import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthenticationService } from './auth.service';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

@Directive({
  selector: '[appHasClaim]',
  standalone: true,
})
export class HasClaimDirective {
  private hasView = false;

  constructor(private authService: AuthenticationService, private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef) { }

  // Will render content if user has this claim or at least one of the claims
  @Input()
  set appHasClaim(oneOfClaims: string|string[]) {
    if (!Array.isArray(oneOfClaims))
      oneOfClaims = [oneOfClaims];
    
    this.authService.hasOneOfClaims(...oneOfClaims).then(condition => {
      if (condition && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!condition && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    });
  }

}

// Activation guard:
// will allow activation if the user has at least one of the claims
export function hasClaimGuard(...oneOfClaims: string[]) {
  const canActivate: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) => {
    const authService = inject(AuthenticationService);
    const router = inject(Router);

    if (!authService.isAuthenticated()) {
      console.debug("User not authenticated, redirecting");

      const redirectUrl = route['_routerState']['url'];

      router.navigateByUrl(
        router.createUrlTree(
          ['/login'], {
            queryParams: {
              redirectUrl
            }
          }
        )
      );
      return false;
    }
  
    return authService.hasOneOfClaims(...oneOfClaims).then(result => {
      if (!result) {
        console.debug(`User does NOT have the '${oneOfClaims}' claim`);
      }

      return result;
    });
  };
  
  return canActivate;
}
